import type {
  AddLineItemsResponse,
  Cart,
  UpdateLineItemResponse,
} from '@/cart/types';

export const cartData: Cart = {
  token: 'super-awesome-random-cart-token',
  note: null,
  attributes: {},
  original_total_price: 3600,
  total_price: 3600,
  total_discount: 0,
  total_weight: 834,
  item_count: 1,
  items: [
    {
      id: 11223344556677,
      properties: null,
      quantity: 1,
      variant_id: 11223344556677,
      key: '11223344556677:25e6e646431555dcecfc70da3a69fcac',
      title: 'Power Pebbles - Dishwasher Tablets - Fragrance Free / 3 Pack',
      price: 3600,
      original_price: 3600,
      discounted_price: 3600,
      line_price: 3600,
      original_line_price: 3600,
      total_discount: 0,
      discounts: [],
      sku: 'H-01-FF30T-03P',
      grams: 834,
      vendor: 'Earth Breeze',
      taxable: true,
      product_id: 7446536618214,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 3600,
      final_line_price: 3600,
      url: '/products/dishwasher-tablets?variant=11223344556677',
      featured_image: {
        aspect_ratio: 1,
        alt: 'Power Pebbles - Dishwasher Tablets',
        height: 1000,
        url: 'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-3Pack-Square.jpg?v=1699548876',
        width: 1000,
      },
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-3Pack-Square.jpg?v=1699548876',
      handle: 'dishwasher-tablets',
      requires_shipping: true,
      product_type: 'dishwasher tablets',
      product_title: 'Power Pebbles - Dishwasher Tablets',
      product_description:
        'An eco-responsible alternative to dishwasher detergent with a powerful clean.',
      variant_title: 'Fragrance Free / 3 Pack',
      variant_options: ['Fragrance Free', '3 Pack'],
      options_with_values: [
        {
          name: 'Scent',
          value: 'Fragrance Free',
        },
        {
          name: 'Pack Size',
          value: '3 Pack',
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {
        min: 1,
        max: null,
        increment: 1,
      },
      has_components: false,
    },
  ],
  requires_shipping: true,
  currency: 'USD',
  items_subtotal_price: 3600,
  cart_level_discount_applications: [],
};

export const cartMultiLine: Cart = {
  token: 'super-awesome-random-cart-token',
  note: null,
  attributes: {},
  original_total_price: 46800,
  total_price: 46800,
  total_discount: 0,
  total_weight: 5426.6228,
  item_count: 4,
  items: [
    {
      id: 12131415161718,
      properties: null,
      quantity: 3,
      variant_id: 12131415161718,
      key: '12131415161718:d314a6d9d3283438b39cf13c21d40206',
      title:
        'Laundry Detergent Eco Sheets - 720 Loads (12 Packs) - Fragrance Free',
      price: 14400,
      original_price: 14400,
      discounted_price: 14400,
      line_price: 43200,
      original_line_price: 43200,
      total_discount: 0,
      discounts: [],
      sku: 'L-02-LS-FF30S-12P',
      grams: 1531,
      vendor: 'tryearthbreeze',
      taxable: true,
      product_id: 7446536913126,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 14400,
      final_line_price: 43200,
      url: '/products/copy-of-earth-breeze-eco-sheets?variant=12131415161718',
      featured_image: {
        aspect_ratio: 1.0,
        alt: 'Laundry Detergent Eco Sheets - 720 Loads (12 Packs)',
        height: 1024,
        url: 'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/FFV212PACKENF_42777638-fb53-49b2-824c-c27ce466e3ab.png?v=1699549080',
        width: 1024,
      },
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/FFV212PACKENF_42777638-fb53-49b2-824c-c27ce466e3ab.png?v=1699549080',
      handle: 'copy-of-earth-breeze-eco-sheets',
      requires_shipping: true,
      product_type: '',
      product_title: 'Laundry Detergent Eco Sheets - 720 Loads (12 Packs)',
      product_description:
        '\nFresh Scent:\u00a0A beautiful fragrance with fresh floral notes that will keep you smelling great.\nFragrance Free:\u00a0Perfect for anyone who may be sensitive to fragrances.',
      variant_title: 'Fragrance Free',
      variant_options: ['Fragrance Free'],
      options_with_values: [
        {name: 'Choose Your Scent', value: 'Fragrance Free'},
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {min: 1, max: null, increment: 1},
      has_components: false,
    },
    {
      id: 11223344556677,
      properties: {},
      quantity: 1,
      variant_id: 11223344556677,
      key: '11223344556677:25e6e646431555dcecfc70da3a69fcac',
      title: 'Power Pebbles - Dishwasher Tablets - Fragrance Free / 3 Pack',
      price: 3600,
      original_price: 3600,
      discounted_price: 3600,
      line_price: 3600,
      original_line_price: 3600,
      total_discount: 0,
      discounts: [],
      sku: 'H-01-FF30T-03P',
      grams: 834,
      vendor: 'Earth Breeze',
      taxable: true,
      product_id: 7446536618214,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 3600,
      final_line_price: 3600,
      url: '/products/dishwasher-tablets?variant=11223344556677',
      featured_image: {
        aspect_ratio: 1.0,
        alt: 'Power Pebbles - Dishwasher Tablets',
        height: 1000,
        url: 'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-3Pack-Square.jpg?v=1699548876',
        width: 1000,
      },
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-3Pack-Square.jpg?v=1699548876',
      handle: 'dishwasher-tablets',
      requires_shipping: true,
      product_type: 'dishwasher tablets',
      product_title: 'Power Pebbles - Dishwasher Tablets',
      product_description:
        'An eco-responsible alternative to dishwasher detergent with a powerful clean.',
      variant_title: 'Fragrance Free / 3 Pack',
      variant_options: ['Fragrance Free', '3 Pack'],
      options_with_values: [
        {name: 'Scent', value: 'Fragrance Free'},
        {name: 'Pack Size', value: '3 Pack'},
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {min: 1, max: null, increment: 1},
      has_components: false,
    },
  ],
  requires_shipping: true,
  currency: 'USD',
  items_subtotal_price: 46800,
  cart_level_discount_applications: [],
};

export const addLineItemResponse: AddLineItemsResponse = {
  items: [
    {
      id: 12131415161718,
      properties: null,
      quantity: 3,
      variant_id: 12131415161718,
      key: '12131415161718:d314a6d9d3283438b39cf13c21d40206',
      title:
        'Laundry Detergent Eco Sheets - 720 Loads (12 Packs) - Fragrance Free',
      price: 14400,
      original_price: 14400,
      discounted_price: 14400,
      line_price: 43200,
      original_line_price: 43200,
      total_discount: 0,
      discounts: [],
      sku: 'L-02-LS-FF30S-12P',
      grams: 1531,
      vendor: 'tryearthbreeze',
      taxable: true,
      product_id: 7446536913126,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 14400,
      final_line_price: 43200,
      url: '/products/copy-of-earth-breeze-eco-sheets?variant=12131415161718',
      featured_image: {
        aspect_ratio: 1.0,
        alt: 'Laundry Detergent Eco Sheets - 720 Loads (12 Packs)',
        height: 1024,
        url: 'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/FFV212PACKENF_42777638-fb53-49b2-824c-c27ce466e3ab.png?v=1699549080',
        width: 1024,
      },
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/FFV212PACKENF_42777638-fb53-49b2-824c-c27ce466e3ab.png?v=1699549080',
      handle: 'copy-of-earth-breeze-eco-sheets',
      requires_shipping: true,
      product_type: '',
      product_title: 'Laundry Detergent Eco Sheets - 720 Loads (12 Packs)',
      untranslated_product_title:
        'Laundry Detergent Eco Sheets - 720 Loads (12 Packs)',
      product_description:
        '\nFresh Scent: A beautiful fragrance with fresh floral notes that will keep you smelling great.\nFragrance Free: Perfect for anyone who may be sensitive to fragrances.',
      variant_title: 'Fragrance Free',
      untranslated_variant_title: 'Fragrance Free',
      variant_options: ['Fragrance Free'],
      options_with_values: [
        {name: 'Choose Your Scent', value: 'Fragrance Free'},
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
    },
  ],
};

export const updateCartResponse: Cart = {
  token: 'super-awesome-random-cart-token',
  note: 'Cowabunga, dude!',
  attributes: {
    'I love': 'being a turtle',
    isTurtle: '1',
  },
  original_total_price: 3600,
  total_price: 3600,
  total_discount: 0,
  total_weight: 834.0,
  item_count: 1,
  items: [
    {
      id: 11223344556677,
      properties: {},
      quantity: 1,
      variant_id: 11223344556677,
      key: '11223344556677:25e6e646431555dcecfc70da3a69fcac',
      title: 'Power Pebbles - Dishwasher Tablets - Fragrance Free / 3 Pack',
      price: 3600,
      original_price: 3600,
      discounted_price: 3600,
      line_price: 3600,
      original_line_price: 3600,
      total_discount: 0,
      discounts: [],
      sku: 'H-01-FF30T-03P',
      grams: 834,
      vendor: 'Earth Breeze',
      taxable: true,
      product_id: 7446536618214,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 3600,
      final_line_price: 3600,
      url: '/products/dishwasher-tablets?variant=11223344556677',
      featured_image: {
        aspect_ratio: 1.0,
        alt: 'Power Pebbles - Dishwasher Tablets',
        height: 1000,
        url: 'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-3Pack-Square.jpg?v=1699548876',
        width: 1000,
      },
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-3Pack-Square.jpg?v=1699548876',
      handle: 'dishwasher-tablets',
      requires_shipping: true,
      product_type: 'dishwasher tablets',
      product_title: 'Power Pebbles - Dishwasher Tablets',
      untranslated_product_title: 'Power Pebbles - Dishwasher Tablets',
      product_description:
        'An eco-responsible alternative to dishwasher detergent with a powerful clean.',
      variant_title: 'Fragrance Free / 3 Pack',
      untranslated_variant_title: 'Fragrance Free / 3 Pack',
      variant_options: ['Fragrance Free', '3 Pack'],
      options_with_values: [
        {
          name: 'Scent',
          value: 'Fragrance Free',
        },
        {
          name: 'Pack Size',
          value: '3 Pack',
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
    },
  ],
  requires_shipping: true,
  currency: 'USD',
  items_subtotal_price: 3600,
  cart_level_discount_applications: [],
};

export const updateLineItemResponse: UpdateLineItemResponse = {
  token: 'super-awesome-random-cart-token',
  note: 'Cowabunga, dude!',
  attributes: {
    'I love': 'being a turtle',
    isTurtle: '1',
  },
  original_total_price: 10800,
  total_price: 10800,
  total_discount: 0,
  total_weight: 2502,
  item_count: 3,
  items: [
    {
      id: 11223344556677,
      properties: {},
      quantity: 3,
      variant_id: 11223344556677,
      key: '11223344556677:25e6e646431555dcecfc70da3a69fcac',
      title: 'Power Pebbles - Dishwasher Tablets - Fragrance Free / 3 Pack',
      price: 3600,
      original_price: 3600,
      discounted_price: 3600,
      line_price: 10800,
      original_line_price: 10800,
      total_discount: 0,
      discounts: [],
      sku: 'H-01-FF30T-03P',
      grams: 834,
      vendor: 'Earth Breeze',
      taxable: true,
      product_id: 7446536618214,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 3600,
      final_line_price: 10800,
      url: '/products/dishwasher-tablets?variant=11223344556677',
      featured_image: {
        aspect_ratio: 1,
        alt: 'Power Pebbles - Dishwasher Tablets',
        height: 1000,
        url: 'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-3Pack-Square.jpg?v=1699548876',
        width: 1000,
      },
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-3Pack-Square.jpg?v=1699548876',
      handle: 'dishwasher-tablets',
      requires_shipping: true,
      product_type: 'dishwasher tablets',
      product_title: 'Power Pebbles - Dishwasher Tablets',
      untranslated_product_title: 'Power Pebbles - Dishwasher Tablets',
      product_description:
        'An eco-responsible alternative to dishwasher detergent with a powerful clean.',
      variant_title: 'Fragrance Free / 3 Pack',
      untranslated_variant_title: 'Fragrance Free / 3 Pack',
      variant_options: ['Fragrance Free', '3 Pack'],
      options_with_values: [
        {
          name: 'Scent',
          value: 'Fragrance Free',
        },
        {
          name: 'Pack Size',
          value: '3 Pack',
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
    },
  ],
  requires_shipping: true,
  currency: 'USD',
  items_subtotal_price: 10800,
  cart_level_discount_applications: [],
  items_added: [],
  items_removed: [],
};

export const removeLineItemResponse: UpdateLineItemResponse = {
  token: 'super-awesome-random-cart-token',
  note: 'Cowabunga, dude!',
  attributes: {
    'I love': 'being a turtle',
    isTurtle: '1',
  },
  original_total_price: 0,
  total_price: 0,
  total_discount: 0,
  total_weight: 0,
  item_count: 0,
  items: [],
  requires_shipping: false,
  currency: 'USD',
  items_subtotal_price: 0,
  cart_level_discount_applications: [],
  items_added: [],
  items_removed: [
    {
      product_id: 7446536618214,
      variant_id: 11223344556677,
      id: 47,
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-3Pack-Square.jpg?v=1699548876',
      price: '36.00',
      quantity: 5,
      title: 'Power Pebbles - Dishwasher Tablets',
      vendor: 'Earth Breeze',
      product_type: 'dishwasher tablets',
      sku: 'H-01-FF30T-03P',
      untranslated_product_title: 'Power Pebbles - Dishwasher Tablets',
      untranslated_variant_title: 'Fragrance Free / 3 Pack',
      view_key: '11223344556677:d2b76599f227dc154fa581f5bef74a76',
    },
  ],
};

export const clearedCart: Cart = {
  token: 'super-awesome-random-cart-token',
  note: 'Cowabunga, dude!',
  attributes: {
    'I love': 'being a turtle',
    isTurtle: '1',
  },
  original_total_price: 0,
  total_price: 0,
  total_discount: 0,
  total_weight: 0.0,
  item_count: 0,
  items: [],
  requires_shipping: false,
  currency: 'USD',
  items_subtotal_price: 0,
  cart_level_discount_applications: [],
};

export const scrollingItemsCart: Cart = {
  token: 'super-awesome-random-cart-token',
  note: null,
  attributes: {},
  original_total_price: 31700,
  total_price: 31700,
  total_discount: 0,
  total_weight: 5164.5442,
  item_count: 5,
  items: [
    {
      id: 11235813213455,
      properties: null,
      quantity: 3,
      variant_id: 11235813213455,
      key: '11235813213455:ff0d9fdf79e3da42e83525ab43fbd860',
      title: 'Power Pebbles - Dishwasher Tablets - Fragrance Free / 4 Pack',
      price: 4800,
      original_price: 4800,
      discounted_price: 4800,
      line_price: 14400,
      original_line_price: 14400,
      total_discount: 0,
      discounts: [],
      sku: 'H-01-FF30T-04P',
      grams: 1112,
      vendor: 'Earth Breeze',
      taxable: true,
      product_id: 7446536618214,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 4800,
      final_line_price: 14400,
      url: '/products/dishwasher-tablets?variant=11235813213455',
      featured_image: {
        aspect_ratio: 1,
        alt: 'Power Pebbles - Dishwasher Tablets',
        height: 1000,
        url: 'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-4Pack-Square.jpg?v=1699548876',
        width: 1000,
      },
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/Fragrance-Free-Front-4Pack-Square.jpg?v=1699548876',
      handle: 'dishwasher-tablets',
      requires_shipping: true,
      product_type: 'dishwasher tablets',
      product_title: 'Power Pebbles - Dishwasher Tablets',
      product_description:
        'An eco-responsible alternative to dishwasher detergent with a powerful clean.',
      variant_title: 'Fragrance Free / 4 Pack',
      variant_options: ['Fragrance Free', '4 Pack'],
      options_with_values: [
        {
          name: 'Scent',
          value: 'Fragrance Free',
        },
        {
          name: 'Pack Size',
          value: '4 Pack',
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {
        min: 1,
        max: null,
        increment: 1,
      },
      has_components: false,
    },
    {
      id: 98765432109876,
      properties: {},
      quantity: 1,
      variant_id: 98765432109876,
      key: '98765432109876:a9c2cd258fdbad56df2c41c08704fc16',
      title:
        'Laundry Detergent Eco Sheets - 720 Loads (12 Packs) - Fresh Scent',
      price: 14400,
      original_price: 14400,
      discounted_price: 14400,
      line_price: 14400,
      original_line_price: 14400,
      total_discount: 0,
      discounts: [],
      sku: 'L-02-LS-FS30S-12P',
      grams: 1463,
      vendor: 'tryearthbreeze',
      taxable: true,
      product_id: 7446536913126,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 14400,
      final_line_price: 14400,
      url: '/products/copy-of-earth-breeze-eco-sheets?variant=98765432109876',
      featured_image: {
        aspect_ratio: 1,
        alt: 'Laundry Detergent Eco Sheets - 720 Loads (12 Packs)',
        height: 1024,
        url: 'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/FSV212PACKENF_8b03fff5-d157-402c-a7ce-65ca613a9284.png?v=1699549080',
        width: 1024,
      },
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/FSV212PACKENF_8b03fff5-d157-402c-a7ce-65ca613a9284.png?v=1699549080',
      handle: 'copy-of-earth-breeze-eco-sheets',
      requires_shipping: true,
      product_type: '',
      product_title: 'Laundry Detergent Eco Sheets - 720 Loads (12 Packs)',
      product_description:
        '\nFresh Scent: A beautiful fragrance with fresh floral notes that will keep you smelling great.\nFragrance Free: Perfect for anyone who may be sensitive to fragrances.',
      variant_title: 'Fresh Scent',
      variant_options: ['Fresh Scent'],
      options_with_values: [
        {
          name: 'Choose Your Scent',
          value: 'Fresh Scent',
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {
        min: 1,
        max: null,
        increment: 1,
      },
      has_components: false,
    },
    {
      id: 12345678901234,
      properties: {},
      quantity: 1,
      variant_id: 12345678901234,
      key: '12345678901234:eef12b0a7ed2853e1d3b502e55242ddf',
      title: 'Laundry Detergent Eco Sheets 3 Pack - Fresh Scent',
      price: 2900,
      original_price: 2900,
      discounted_price: 2900,
      line_price: 2900,
      original_line_price: 2900,
      total_discount: 0,
      discounts: [],
      sku: 'L-02-LS-FS30S-03P',
      grams: 366,
      vendor: 'tryearthbreeze',
      taxable: true,
      product_id: 7446536782054,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 2900,
      final_line_price: 2900,
      url: '/products/earth-breeze-eco-sheets-3-pack?variant=12345678901234',
      featured_image: {
        aspect_ratio: 1,
        alt: 'Laundry Detergent Eco Sheets 3 Pack',
        height: 1024,
        url: 'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/ebus3pk-fs_9e8f58a9-1403-46c8-8552-355e247caa57.png?v=1699549119',
        width: 1024,
      },
      image:
        'https://cdn.shopify.com/s/files/1/0610/3488/9446/products/ebus3pk-fs_9e8f58a9-1403-46c8-8552-355e247caa57.png?v=1699549119',
      handle: 'earth-breeze-eco-sheets-3-pack',
      requires_shipping: true,
      product_type: '',
      product_title: 'Laundry Detergent Eco Sheets 3 Pack',
      product_description:
        '\nFresh Scent: A beautiful fragrance with fresh floral notes that will keep you smelling great.\nFragrance Free: Perfect for anyone who may be sensitive to fragrances.',
      variant_title: 'Fresh Scent',
      variant_options: ['Fresh Scent'],
      options_with_values: [
        {
          name: 'Choose Your Scent',
          value: 'Fresh Scent',
        },
      ],
      line_level_discount_allocations: [],
      line_level_total_discount: 0,
      quantity_rule: {
        min: 1,
        max: null,
        increment: 1,
      },
      has_components: false,
    },
  ],
  requires_shipping: true,
  currency: 'USD',
  items_subtotal_price: 31700,
  cart_level_discount_applications: [],
};
